import { createReducer } from '@reduxjs/toolkit';
import { type GooglePayStore } from '../../types/StoreState';
import { setGooglePayPaymentDataShippingMethods } from '../../actions/googlePay/common';

export const googlePayPaymentDataInitialState: GooglePayStore['paymentData'] = {
  shippingMethods: [],
};

export const googlePayPaymentDataReducer = createReducer(googlePayPaymentDataInitialState, (builder) => {
  builder.addCase(setGooglePayPaymentDataShippingMethods, (state, action) => {
    state.shippingMethods = action.payload;
  });
});
